/**
 * available shortcut key mappings
 */
export const ShortCutKeys = {
  AltEnter: 'alt+enter',
  AltP: 'alt+p',
  AltC: 'alt+c',
  AltM: 'alt+m',
};
